export default __webpack_public_path__ + "static/media/warning--railroad-intersection--g3.025e4551.png";